import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { Router } from '@angular/router';
import { MapForumComponent } from '../../nearby-map/map-forum/map-forum.component';
import { CommonService } from 'src/app/shareModule/services/common.service';

@Component({
  selector: 'app-product-faq-list',
  templateUrl: './product-faq-list.component.html',
  styleUrl: './product-faq-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductFaqListComponent implements OnChanges, OnInit, OnDestroy {
  public faqProducts = [null, null, null, null, null];
  @Input() filter: string = '';
  @Input() filterId: string = '';
  @Input() filterForum: string = '';
  @Input() viewOpenModelAddQuestion: boolean = true;
  @Input() isSelectSubCat: boolean = false;

  backgroundColor = 'var(--primary)';
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['categoryId']) {
      const prevCategoryId = changes['categoryId'].previousValue;
      const currCategoryId = changes['categoryId'].currentValue;
      if (prevCategoryId != currCategoryId) {
        this._fetchProductSubCategoryFAQInfos();
      }
    }
    if (changes['additionalFAQS']) {
      try {
        this.additionalFAQS = JSON.parse(
          this.additionalFAQS ? this.additionalFAQS : '[]'
        );
      } catch (e) {
        console.error(e);
      }
    }

    if (changes['filter'] || changes['filterId']) {
      const prevFilter = changes['filter']?.previousValue;
      const currFilter = changes['filter']?.currentValue;
      const prevFilterId = changes['filterId']?.previousValue;
      const currFilterId = changes['filterId']?.currentValue;
      if (prevFilter !== currFilter || prevFilterId !== currFilterId) {
        this._fetchFilteredFAQData();
        this.cdr.detectChanges();
      }
    }
  }
  public get isPopup(): boolean {
    return (
      this.sharedService.isBrowser() &&
      window.location.href.includes('?product')
    );
  }

  constructor(
    private sharedService: SharedService,
    private auth: AuthServiceService,
    private seoService: SeoService,
    private modalService: NgbModal,
    private local: LocalServiceService,
    private roleService: RoleService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private customerService: CustomerService,
    private router: Router,
    public commonService: CommonService
  ) { }

  private destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this._roleSubscription?.unsubscribe();
  }

  private _roleSubscription: Subscription | null = null;
  ngOnInit(): void {
    this._roleSubscription = this.roleService.rolesSubject.subscribe(() => {
      this.isUserAdmin = this.roleService?.roles?.userType.includes('ADMIN');
    });

    this.commonService.mapCustomizationObserver.subscribe((data) => {
      this.backgroundColor = data?.faqQuestionFieldColor ?? 'var(--primary)';
      this.cdr.detectChanges();
    });
  }

  public get catFaqExist() {
    const keys = [
      'questionOne',
      'answerOne',
      'questionTwo',
      'answerTwo',
      'questionThree',
      'answerThree',
      'questionFour',
      'answerFour',
      'questionFive',
      'answerFive',
    ];
    let strOn =
      this.faqInfos &&
      this.faqInfos != 'null' &&
      typeof this.faqInfos == 'string' &&
      this.faqInfos;

    if (this.faqInfos && typeof this.faqInfos == 'object') {
      for (const key of keys) {
        if (this.faqInfos[key]) {
          return true;
        }
      }
    }
    return strOn;
  }
  @Output()
  public faqsExist = new EventEmitter();

  @Input()
  public categoryId: any;

  @Input()
  public additionalFAQS;

  convertBreakline(value?: string) {
    return value?.replace(/\n/g, '<br>');
  }

  public approveFaq(faq, type) {
    this.auth.toggleFaqApproval(faq.id, type).subscribe({
      next: () => {
        faq.isApproved = !!faq.isApproved;
        // this._fetchCommunityQuestionsAnswers()
      },
    });
  }
  public faqInfos = null;
  public productFAQs = [];
  private _fetchCommunityQuestionsAnswers() {
    // this.auth
    //   .getCommunityFAQQuestionsOfCategory(this.categoryId)
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe({
    //     next: (data) => {
    //       // Community questions functionality moved to map-forum component
    //       this.cdr.detectChanges();
    //     },
    //     error: console.error,
    //   });
  }

  private _fetchProductSubCategoryFAQInfos() {
    if (!(this.categoryId && this.categoryId != -1)) {
      return;
    }
    // Community questions functionality moved to map-forum component

    // this.auth.getCategoryFAQInfo(this.categoryId)
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe({
    //     next: (data: any) => {
    //       if (!data?.body?.faqInfos) {
    //         return;
    //       }
    //       this.faqInfos = data.body.faqInfos;

    //       this.faqInfos.answerOne = this.convertBreakline(
    //         this.faqInfos.answerOne
    //       );
    //       this.faqInfos.answerTwo = this.convertBreakline(
    //         this.faqInfos.answerTwo
    //       );
    //       this.faqInfos.answerThree = this.convertBreakline(
    //         this.faqInfos.answerThree
    //       );
    //       this.faqInfos.answerFour = this.convertBreakline(
    //         this.faqInfos.answerFour
    //       );
    //       this.faqInfos.answerFive = this.convertBreakline(
    //         this.faqInfos.answerFive
    //       );

    //       const suffix = ['One', 'Two', 'Three', 'Four', 'Five']

    //       for (let i = 0; i < suffix.length; i++) {

    //         const s = suffix[i];
    //         const key = 'attachedProductSlug' + s;

    //         if (this.faqInfos[key]) {
    //           this.auth.getShopProductDetails({ productId: this.faqInfos[key]?.trim() }).subscribe({
    //             next: data => {
    //               this.faqProducts[i] = data.body
    //             }
    //           })
    //         }

    //       }
    //       const val = this.catFaqExist || (Array.isArray(this.additionalFAQS) && this.additionalFAQS?.length > 0)
    //       ////console.log("emitting", val, this.faqInfos)
    //       //console.log("Emitting exist", val, "others", this.catFaqExist, this.additionalFAQS)

    //       this.initSchema()
    //       this.faqsExist.emit(val);
    //       this.cdr.detectChanges()
    //     },
    //     error: console.error,
    //   });
  }

  public countForumMap = 0;
  private _fetchFilteredFAQData() {
    this.customerService
      .countForumMap({ filterForum: this.filterForum })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.countForumMap = data.body;
          this.cdr.detectChanges();
        },
        error: console.error,
      });
    this.customerService
      .getMemberShopCategoriesFAQ({
        filter: this.filter,
        filterId: this.filterId,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          const response = data.body;
          if (!response) {
            this.faqInfos = null;
            this.cdr.detectChanges();
            return;
          }
          this.faqInfos = {
            answerOne: this.convertBreakline(response.answer[0]),
            answerTwo: this.convertBreakline(response.answer[1]),
            answerThree: this.convertBreakline(response.answer[2]),
            answerFour: this.convertBreakline(response.answer[3]),
            answerFive: this.convertBreakline(response.answer[4]),
            questionOne: this.convertBreakline(response.question[0]),
            questionTwo: this.convertBreakline(response.question[1]),
            questionThree: this.convertBreakline(response.question[2]),
            questionFour: this.convertBreakline(response.question[3]),
            questionFive: this.convertBreakline(response.question[4]),

            attachedProductSlugOne: response.attachedProductSlug[0],
            attachedProductSlugTwo: response.attachedProductSlug[1],
            attachedProductSlugThree: response.attachedProductSlug[2],
            attachedProductSlugFour: response.attachedProductSlug[3],
            attachedProductSlugFive: response.attachedProductSlug[4],
          };
          const suffix = ['One', 'Two', 'Three', 'Four', 'Five'];

          for (let i = 0; i < suffix.length; i++) {
            const s = suffix[i];
            const key = 'attachedProductSlug' + s;

            if (this.faqInfos[key]) {
              this.auth
                .getShopProductDetails({
                  productId: this.faqInfos[key]?.trim(),
                })
                .subscribe({
                  next: (data) => {
                    this.faqProducts[i] = data.body;
                  },
                });
            }
          }
          const val =
            this.catFaqExist ||
            (Array.isArray(this.additionalFAQS) &&
              this.additionalFAQS?.length > 0);
          ////console.log("emitting", val, this.faqInfos)
          //console.log("Emitting exist", val, "others", this.catFaqExist, this.additionalFAQS)

          this.initSchema();
          this.faqsExist.emit(val);
          this.cdr.detectChanges();
          this.cdr.detectChanges();
        },
        error: console.error,
      });
  }
  public showFAQ(i) {
    if (this.visibleFAQ[i]) {
      this.visibleFAQ[i] = false;
    } else {
      this.visibleFAQ.fill(false);
      this.visibleFAQ[i] = true;
    }
  }
  public visibleFAQ = new Array(5);
  closeAllFaq() {
    this.visibleFAQ = new Array(5);
  }

  initSchema() {
    const listFAQ = [
      this.faqInfos.questionOne,
      this.faqInfos.questionTwo,
      this.faqInfos.questionThree,
      this.faqInfos.questionFour,
      this.faqInfos.questionFive,
    ];
    const listFAQAnswer = [
      this.faqInfos.answerOne,
      this.faqInfos.answerTwo,
      this.faqInfos.answerThree,
      this.faqInfos.answerFour,
      this.faqInfos.answerFive,
    ];

    ////console.log(listFAQ, listFAQAnswer)
    const schema = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: listFAQ
        .filter((row) => row)
        .map((row, index) => {
          return {
            '@type': 'Question',
            name: row,
            acceptedAnswer: {
              '@type': 'Answer',
              text: listFAQAnswer[index],
            },
          };
        }),
    });

    this.seoService.updateSchema('custom', schema);
  }

  /******************** Code related to asking questions  *************************/
  @ViewChild('askQuestionAboutCategory')
  public askQuestionAboutCategoryModal: TemplateRef<any>;

  @ViewChild('answerQuestion')
  public answerQuestionModal: TemplateRef<any>;


  public askQuestionText = '';
  public answerQuestionText = '';
  public answeringQuestion = null;
  public selectedImage: string | null = null;
  public selectedImageFile: File | null = null;


  public openAskQuestionsModal() {
    this.askQuestionText = '';
    this.selectedImage = null;
    this.selectedImageFile = null;
    if (this.viewOpenModelAddQuestion) {
      this.modalService.open(this.askQuestionAboutCategoryModal, {
        size: 'md',
      });
    }
  }

  public onImageSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        this.toastr.error('Please select a valid image file');
        return;
      }

      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        this.toastr.error('Image size should be less than 5MB');
        return;
      }

      this.selectedImageFile = file;

      // Create preview URL
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.selectedImage = e.target.result;
        this.cdr.detectChanges();
      };
      reader.readAsDataURL(file);
    }
  }

  public removeImage(event: Event): void {
    event.stopPropagation(); // Prevent triggering file input
    this.selectedImage = null;
    this.selectedImageFile = null;
    this.cdr.detectChanges();
  }

  public addAnswerQuestion() {
    this.auth
      .answerToCommunityFAQQuestion(
        this.answeringQuestion?.id,
        this.answerQuestionText
      )
      .subscribe({
        next: () => {
          this.toastr.success('Answer posted');
          this.modalService.dismissAll();
          this._fetchCommunityQuestionsAnswers();
        },
        error: (err) => {
          this.toastr.error(err.error.message);
        },
      });
  }
  public openAnswerQuestionModal(question) {
    this.answeringQuestion = question;
    this.answerQuestionText = '';
    this.modalService.open(this.answerQuestionModal, { size: 'md' });
  }

  public removeAnswer(answer) {
    this.local
      .confirmYesNo({
        title: 'Are you sure you want to remove this answer',
        text: '',
        icon: 'info',
      })
      .then((res) => { });
  }

  public isUserAdmin = false;
  public addQuestionToForumMap() {
    // Merge selected image into text as <img> element instead of uploading binary
    let textToSend = this.askQuestionText || '';
    if (this.selectedImage) {
      const imgTag = `<p><img src="${this.selectedImage}" alt="question image" /></p>`;
      textToSend = textToSend ? `${textToSend}\n${imgTag}` : imgTag;
    }

    const payload = {
      categoryId: this.categoryId,
      text: textToSend,
      filter: this.filter,
      filterId: this.filterId,
      filterForum: this.filterForum,
    };

    this.auth
      .addForumMap(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.toastr.success('Question added');
          this._fetchCommunityQuestionsAnswers();
          this.askQuestionText = '';
          this.selectedImage = null;
          this.selectedImageFile = null;
          if (this.viewOpenModelAddQuestion) {
            this.modalService.dismissAll();
          }
        },
        error: (err) => {
          this.toastr.error(err.error.message);
        },
      });
  }
  public removeQuestion(question) {
    this.local
      .confirmYesNo({
        title: 'Are you sure you want to remove this question',
        text: '',
        icon: 'info',
      })
      .then((res) => {
        if (res.isConfirmed) {
          this.auth
            .removeCommunityFAQQuestionFromCategory(question.id)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => {
                this.toastr.success('remove');
                this._fetchCommunityQuestionsAnswers();
              },
              error: (err) => {
                this.toastr.error(err.error.message);
              },
            });
        }
      });
  }
  public areAnswerVisisbleCommunityQuestions = [false];

  public toggelViewAnswersToCommunityQuestions(index) {
    this.areAnswerVisisbleCommunityQuestions[index] =
      !this.areAnswerVisisbleCommunityQuestions[index];
  }

  /******************** Code related to community questions modal  *************************/
  public openCommunityQuestionsModal() {
    const modalRef = this.modalService.open(MapForumComponent, {
      size: 'md',
      windowClass: 'community-questions-modal',
    });

    const componentInstance = modalRef.componentInstance as MapForumComponent;
    componentInstance.categoryId = this.categoryId
    componentInstance.filter = this.filter
    componentInstance.filterId = this.filterId
    componentInstance.filterForum = this.filterForum
  }

  public toggleHeartCommunityQuestion(question) {
    this.auth
      .toggleCommunityFAQQuestionReaction(question.id, 'question')
      .subscribe({
        next: () => {
          question.isLiked = !question.isLiked;
          if (question.isLiked) {
            question.likeCount += 1;
          } else {
            question.likeCount -= 1;
          }
        },
        error: (err) => {
          this.toastr.error(err.error.message);
        },
      });
  }

  public toggleHeartCommunityAnswer(answer) {
    this.auth
      .toggleCommunityFAQQuestionReaction(answer.id, 'answer')
      .subscribe({
        next: () => {
          answer.isLiked = !answer.isLiked;
          if (answer.isLiked) {
            answer.likeCount += 1;
          } else {
            answer.likeCount -= 1;
          }
        },
        error: () => {
          this.toastr.error('Something went wrong please try again latter');
        },
      });
  }

}
